export default __webpack_public_path__ + "static/thin-wave-2-2cf1281c2068112482a9cba5a07758da.png";